'use client';

export function StatusPagePrintStyles() {
  return <style dangerouslySetInnerHTML={{ __html: PRINT_STYLES }} />;
}

const PRINT_STYLES = `
  @media print {
    .status-page-print,
    .status-page-print * {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
    /* The reCAPTCHA badge is fixed outside .status-page-print and spills onto an extra page */
    .grecaptcha-badge {
      display: none !important;
    }
    /* Flow content from the top instead of vertically centered on the viewport */
    .status-page-print .min-h-screen {
      min-height: 0 !important;
      justify-content: flex-start !important;
    }
    /* The root layout pins html/body to height: 100%, which on mobile is one viewport tall and can push the content to the next page */
    html,
    body {
      height: auto !important;
    }
    /* Nested flex wrappers are not split across pages, so a tall receipt jumps whole to page 2 and leaves only the header on page 1 */
    .status-page-print .min-h-screen,
    .status-page-print .min-h-screen > div,
    .status-page-print [data-testid="left-content"],
    .status-page-print [data-testid="rigth-content"],
    .status-page-print :has(> [class*="max-w-[416px]"]) {
      display: block !important;
    }
    /* Trailing bottom padding of the layout wrappers overflows the page by a few pixels and prints an extra page with only background */
    .status-page-print [class*="pb-jade-300"] {
      padding-bottom: 0 !important;
    }
    .status-page-print [class*="max-w-[416px]"] {
      margin: 0 auto !important;
      padding-top: 24px !important;
    }
    /* Expand the scrollable order details so every item prints */
    .status-page-print [data-testid="checkout-details"] {
      max-height: none !important;
      overflow: visible !important;
    }
    /* Hide interactive controls — they are not part of the printed receipt */
    .status-page-print button {
      display: none !important;
    }
    /* Avoid splitting cards across pages */
    .status-page-print [data-testid="checkout-details"],
    .status-page-print [aria-label] {
      break-inside: avoid;
    }
    /* Shrink slightly so the whole receipt fits on a single page */
    .status-page-print {
      zoom: 0.75;
    }
  }

  @page {
    margin: 12mm;
  }
`;
